import { ReactComponent as Diamond } from "assets/icons/diamond.svg";
import { ReactComponent as BlackWeight } from "assets/icons/Set Tray Icon/gold.svg";
import { ReactComponent as Weight } from "assets/icons/small.svg";
import { ReactComponent as BlackGemStone } from "assets/icons/BlackGemStone.svg";
import { ReactComponent as GemStone } from "assets/icons/GemStone.svg";
import { ReactComponent as BlackOtherMaterial } from "assets/icons/BlackOtherMaterial.svg";
import { ReactComponent as OtherMaterial } from "assets/icons/OtherMaterial.svg";
import { ReactComponent as Sales_black } from "assets/sale_icon/sale_Black.svg";
import { ReactComponent as Sales } from "assets/sale_icon/sale.svg";
import { ReactComponent as BlackScale } from "assets/icons/BlackScale.svg";
import { ReactComponent as Scale } from "assets/icons/Scale.svg";
import { ReactComponent as RatioIcon } from "assets/icons/Ratio.svg";
import { ReactComponent as RatioBlackIcon } from "assets/icons/RatioIconBlack.svg";
import { ReactComponent as BlackDateIcon } from "assets/icons/Black_Calender.svg";
import { ReactComponent as DateIcon } from "assets/icons/date.svg";
import { ReactComponent as BalckCollectionIcon } from "assets/icons/Set Tray Icon/collection.svg";
import { ReactComponent as CollectionIcon } from "assets/sidebar/enable/collection.svg";
import { ReactComponent as SetsIcons } from "assets/sidebar/enable/sets.svg";
import { ReactComponent as GoldCup } from "assets/cup_icon/gold-cup.svg";
import { ReactComponent as SilverCup } from "assets/cup_icon/silver-cup.svg";
import { ReactComponent as BronzeCup } from "assets/cup_icon/brown-cup.svg";
import { ReactComponent as CadIcon_Black } from "assets/icons/Cad_Black.svg";
import { ReactComponent as CadIcon } from "assets/icons/Cad.svg";
import { ReactComponent as StockCountIcon } from "assets/icons/StockCount.svg";

import { ReactComponent as R_labor_black } from "assets/labor_icon/R_Black.svg";
import { ReactComponent as X_labor_black } from "assets/labor_icon/X_Black.svg";
import { ReactComponent as X2_labor_black } from "assets/labor_icon/X2_Black.svg";
import { ReactComponent as X5_labor_black } from "assets/labor_icon/X5_Black.svg";
import { ReactComponent as X8_labor_black } from "assets/labor_icon/X8_Black.svg";
import { ReactComponent as XX_labor_black } from "assets/labor_icon/XX_Black.svg";

import { ReactComponent as R_labor } from "assets/labor_icon/R.svg";
import { ReactComponent as X_labor } from "assets/labor_icon/X.svg";
import { ReactComponent as X2_labor } from "assets/labor_icon/X2.svg";
import { ReactComponent as X5_labor } from "assets/labor_icon/X5.svg";
import { ReactComponent as X8_labor } from "assets/labor_icon/X8.svg";
import { ReactComponent as XX_labor } from "assets/labor_icon/XX.svg";

import { ReactComponent as Gold } from "assets/icons/gold.svg";
import { ReactComponent as Bronze } from "assets/icons/brozen.svg";
import { ReactComponent as Silver } from "assets/icons/sliver.svg";
import { ReactComponent as UnderRatio } from "assets/icons/underRatio.svg";
import { ReactComponent as ReorderIcon } from "assets/productIcon/reorder.svg";

import { ReactComponent as Ring } from "assets/icons/Ring.svg";
import { ReactComponent as Memo } from "assets/icons/Memo.svg";
import { ReactComponent as EyeBtn } from "assets/icons/CatalogueCard/eye.svg";

import { ReactComponent as BBM } from "assets/icons/BBM.svg";
import { ReactComponent as BBS } from "assets/icons/BBS.svg";
import { ReactComponent as HQ } from "assets/icons/HQ.svg";
import { ReactComponent as BBMC } from "assets/icons/bbm_cust.svg";
import { ReactComponent as BBSC } from "assets/icons/bbs_cust.svg";
import { ReactComponent as IDL } from "assets/icons/IDL.svg";
// import { ReactComponent as SoldIcon } from "../assets/icons/SoldIcon.svg";

import { ReactComponent as InStock } from "assets/icons/InStock.svg";
import { ReactComponent as OutOfStock } from "assets/icons/OutOfStock.svg";

import { ReactComponent as CatalogClientReportProductViewEye } from "assets/catalogSetting/ViewProduct/eye.svg";
import { ReactComponent as CatalogClientReportProductCart } from "assets/catalogSetting/ViewProduct/Cart.svg";
import { ReactComponent as CatalogClientReportProductRemoveCart } from "assets/catalogSetting/ViewProduct/RemoveCart.svg";
import { ReactComponent as CatalogClientReportProductClock } from "assets/catalogSetting/ViewProduct/Clock.svg";
import { ReactComponent as BlackDimondIcon } from "assets/icons/Set Tray Icon/Diamond.svg";

import { ReactComponent as SalesAverage } from "assets/icons/salesAverage.svg";
import { ReactComponent as BlackBabor } from "assets/icons/Set Tray Icon/Labor.svg";
import { ReactComponent as Babor } from "assets/icons/babor.svg";

import { ReactComponent as BlackEyeBtn } from "assets/icons/BlackEyeIcon.svg";


export const getProductIcon = (type, variant) => {
  const icons = {
    date: variant === "black" ? BlackDateIcon : DateIcon,
    diamond: variant === "black" ? BlackDimondIcon : Diamond,
    gemstone: variant === "black" ? BlackGemStone : GemStone,
    otherMaterial: variant === "black" ? BlackOtherMaterial : OtherMaterial,
    sales: variant === "black" ? Sales_black : Sales,
    scale: variant === "black" ? BlackScale : Scale,
    goldbar: variant === "black" ? BlackWeight : Weight,
    labour: variant === "black" ? BlackBabor : Babor,
    RatioIcon: variant === "black" ? RatioBlackIcon : RatioIcon,
    collection: variant === "black" ? BalckCollectionIcon : CollectionIcon,
    set: variant === "black" ? SetsIcons : SetsIcons,
    gold_cup: variant === "black" ? GoldCup : GoldCup,
    silver_cup: variant === "black" ? SilverCup : SilverCup,
    bronze_cup: variant === "black" ? BronzeCup : BronzeCup,
    cadIcon: variant === "black" ? CadIcon_Black : CadIcon,
    stockCount: variant === "black" ? StockCountIcon : StockCountIcon,

    r_labor: variant === "black" ? R_labor_black : R_labor,
    x_labor: variant === "black" ? X_labor_black : X_labor,
    x2_labor: variant === "black" ? X2_labor_black : X2_labor,
    x5_labor: variant === "black" ? X5_labor_black : X5_labor,
    x8_labor: variant === "black" ? X8_labor_black : X8_labor,
    xx_labor: variant === "black" ? XX_labor_black : XX_labor,
    bronze: variant === "black" ? Bronze : Bronze,
    silver: variant === "black" ? Silver : Silver,
    gold: variant === "black" ? Gold : Gold,
    "under ratio": variant === "black" ? UnderRatio : UnderRatio,
    reorderIcon: variant === "black" ? ReorderIcon : ReorderIcon,

    //stockCardIcons
    ring: variant === "black" ? Ring : Ring,
    Memo: Memo,
    eye: variant === "black" ? BlackEyeBtn : EyeBtn,
    bbm: variant === "black" ? BBM : BBM,
    idl: variant === "black" ? IDL : IDL,
    bbs: variant === "black" ? BBS : BBS,
    hq: variant === "black" ? HQ : HQ,
    bbmC: variant === "black" ? BBMC : BBMC,
    bbsC: variant === "black" ? BBSC : BBSC,
    idl: variant === "black" ? IDL : IDL,
    // sold: variant === "red" ?SoldIcon  : SoldIcon ,

    in_stock: variant === "black" ? InStock : InStock,
    out_stock: variant === "black" ? OutOfStock : OutOfStock,

    catalogView: variant === "black" ? CatalogClientReportProductViewEye : CatalogClientReportProductViewEye,
    catalogCart: variant === "black" ? CatalogClientReportProductCart : CatalogClientReportProductCart,
    catalogRemoveCart: variant === "black" ? CatalogClientReportProductRemoveCart : CatalogClientReportProductRemoveCart,
    catalogClock: variant === "black" ? CatalogClientReportProductClock : CatalogClientReportProductClock,

    //Sets
    sales_average: variant === "black" ? SalesAverage : SalesAverage,
    R: variant === "black" ? R_labor_black : R_labor,
  };

  const largeIcons = ["bronze", "silver", "gold", "under ratio"];

  const IconComponent = icons[type];
  const size = largeIcons.includes(type) ? 20 : 18;

  return IconComponent ? (
    <IconComponent
      style={{
        width: `${size}px`,
        height: `${size}px`,
        maxWidth: `${size}px`,
        maxHeight: `${size}px`,
        ...((type === "ring" || type === "diamond") && variant === "black" ? { filter: "brightness(0)" } : {}),
      }}
    />
  ) : null;
};
